import {IntegrationCertificateEnum} from 'admin/integrations/enums';

export const SUPPORTED_CERTIFICATE_FORMATS = [IntegrationCertificateEnum.P12];
